module.exports = __webpack_public_path__ + "img/ins_step4_success.920296de.svg";